import { Product } from './product.model';
import { Benchmark } from './benchmark.model';

export class PortfolioComponent extends Product {
  public benchmark: Benchmark;
  public weight: number = 0;
}